import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { AgentService } from '../services/agent.service';
import { AgentPartyIdentityHandlerComponent } from './agent-party-identity.handler';

@Component({
  selector: 'sym-agent-party-identity',
  templateUrl: './agent-party-identity.component.html',
  styleUrls: ['./agent-party-identity.component.scss'],
})
export class AgentPartyIdentityComponent extends AgentPartyIdentityHandlerComponent {
  @Input() partyModel: any;

  constructor(agentService: AgentService) {
    super(agentService);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['partyModel'] && changes['partyModel'].currentValue) {
      this.service.responseIO.lookups.IDENTITYTYPE.filter((identitycd) => {
        if (identitycd.cd == 'PAN') {
          this.service.responseIO.lookups.IDENTITYTYPE = [];
          this.service.responseIO.lookups.IDENTITYTYPE.push(identitycd);
        }
      });
      this.partyModel = this.partyModel;
    }
  }
}
